import { Moment } from 'moment';
import { BaseModel } from '../base-model';
import { IEvent } from '.';
export interface ISelecteInfo {
  start: Moment;
  end: Date | Moment | any;
  resourceId: number;
}

export interface IResource {
  id: string;
  title: string;
  description: string;
  eventColor: string;
  eventBackgroundColor: string;
  eventBorderColor: string;
  eventTextColor: string;
  eventClassName: string;
  businessHours: any;
  children: any;
  parentId: string;
  parent: any;
}
export interface IView {
  name: string;
  title: string;
  start: Moment;
  end: Moment;
  intervalStart: Moment;
  intervalEnd: Moment;
  type: string;
}
export interface IHeader {
  left: string;
  center: string;
  right: string;
}
export class Header {
  left: string;
  center: string;
  right: string;
  /**
   *
   */
  constructor(value: Header) {
    this.left = value.left;
    this.center = value.center;
    this.right = value.right;
  }
}
export interface ICustomButtons {
  text: string;
  click(): void;
}

export interface ICalendarOptions {
  editable?: boolean;
  schedulerLicenseKey?: string;
  slotDuration?: string | object;
  themeSystem?: string;
  locale?: string;
  axisFormat?: string;
  defaultView?: string;
  defaultDate?: Moment;
  timezone?: string;
  eventLimit?: boolean | number;
  lazyFetching?: boolean;
  groupByResource?: boolean;
  groupByDateAndResource?: boolean;
  slotEventOverlap?: boolean;
  header?: IHeader | boolean;
  handleWindowResize?: boolean;
  footer?: IHeader;
  customButtons?: ICustomButtons;
  refetchResourcesOnNavigate?: boolean;
  filterResourcesWithEvents?: boolean;
  slotLabelFormat?: string;
  selectable?: boolean;
  timeFormat?: string;
  nowIndicator?: boolean;
  selectHelper?: boolean;
  unselectAuto?: boolean;
  unselectCancel?: boolean;
  minTime?: string;
  maxTime?: string;
  buttonText?: any;
  firstDay?: number;
  contentHeight?: number | string;
  height?: number | string;
  defaultAllDayEventDuration?: string | object;
  aspectRatio?: number;
  slotLabelInterval?: string | object;
  droppable?: boolean;
  dropAccept?: string;
  initialDate?: string;

  selectOverlap(event?: any): void;
  selectAllow(selectInfo: ISelecteInfo): void;
  select(start?: Moment, end?: Moment, jsEvent?: any, view?: IView, resource?: any[]): void;
  select(method: 'select', end?: Moment[], resource?: any[]): void;
  unselect(jsEvent?: any, view?: IView);
  unselect(method: 'unselect');
  loading(isLoading: boolean, view: IView);
  events(start: Moment | null, end: Moment | null, timezone?: any, callback?: any): IEvent[] | void;
  eventSources(start: Moment | null, end: Moment | null, timezone?: any, callback?: any);
  resources(callback?: any, start?: Moment | null, end?: Moment | null, timezone?: any): IResource[] | void;
  eventClick(event: IEvent | null, jsEvent: any | null, view: any | null): any;
  viewRender(view: IView, element: any);
  eventDragStart(event: IEvent, jsEvent: any, ui: any, view: IView);
  eventDragStop(event: IEvent, jsEvent: any, ui: any, view: IView);
  eventDrop(event: IEvent, delta: any, revertFunc: any, jsEvent: any, ui: any, view: IView);
  eventResizeStart(event: IEvent, jsEvent: any, ui: any, view: IView);
  eventResizeStop(event: IEvent, jsEvent: any, ui: any, view: IView);
  eventResize(event: IEvent, delta: any, revertFunc: any, jsEvent: any, ui: any, view: IView);
  eventRender(event?: IEvent, element?: any, view?: IView);
  eventMouseover(data: any, event: IEvent, view: IView);
  eventMouseout(calEvent, jsEvent);
  eventAfterAllRender(view: IView);
  windowResize(view: IView);
  drop(date: Moment, jsEvent: any, ui: any, resourceId: any);
  calendarKey?: string;
}

export class CalendarOptions extends BaseModel<CalendarOptions> {
  editable?: boolean;
  schedulerLicenseKey?: string;

  slotDuration?: string | object;
  themeSystem?: string;
  locale?: string;
  axisFormat?: string;
  defaultView?: string;
  defaultDate?: Moment;
  timezone?: string;
  eventLimit?: boolean | number;
  lazyFetching?: boolean;
  groupByResource?: boolean;
  groupByDateAndResource?: boolean;
  slotEventOverlap?: boolean;
  header?: IHeader | boolean;
  handleWindowResize?: boolean;
  footer?: IHeader;
  customButtons?: any
  refetchResourcesOnNavigate?: boolean;
  filterResourcesWithEvents?: boolean;
  slotLabelFormat?: string;
  selectable?: boolean;
  timeFormat?: string;
  nowIndicator?: boolean;
  selectHelper?: boolean;
  unselectAuto?: boolean;
  unselectCancel?: boolean;
  minTime?: string;
  maxTime?: string;
  calendarKey?: string;
  titleFormat?: string;
  views: any;
  buttonText?: any;
  allDaySlot?: boolean;
  firstDay?: number;
  contentHeight?: number | string;
  height?: number | string;
  defaultAllDayEventDuration?: string | object;
  aspectRatio?: number;
  slotLabelInterval?: string | object;
  droppable?: boolean;
  dropAccept?: string;
  initialDate?: string;
  showNonCurrentDates?: boolean;
  /**
   *
   */
  constructor(owner: number, options: CalendarOptions) {
    super(options);
    this.lazyFetching = true;
    this.handleWindowResize = true;
    this.eventLimit = true;
    this.slotDuration = options.slotDuration || { "minute": 15 };
    this.slotLabelFormat = 'HH:mm';
    this.timeFormat = 'HH:mm';
    this.editable = true;
    this.slotEventOverlap = false;
    this.selectable = true;
    this.calendarKey = 'GPL-My-Project-Is-Open-Source';
    this.schedulerLicenseKey = 'CC-Attribution-NonCommercial-NoDerivatives';
    this.firstDay = 1; // The first day of week (english Sunday = 0)
    this.header = {left: '', center: '', right: ''};
    this.aspectRatio = options.aspectRatio || 2;
    // this.height = options.height || "auto";
    this.contentHeight = options.contentHeight || "auto";
    this.slotLabelInterval = options.slotLabelInterval;
    this.droppable = options.droppable || false;
    this.showNonCurrentDates = options.showNonCurrentDates || true;
  }
}


